import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { createDemoFavorite, deleteDemoFavorite, } from '../../../actions/DemoSolutionActions';
import { apiCreateFavorite, apiDeleteFavorite, } from '../../../actions/FavoriteActions';
import { isClient as isClientMember } from '../../../helpers/auth';
import { propBool, propFunc, propShape, propStr, } from '../../../helpers/custom-prop-types';
import { isLoadingApis } from '../../../helpers/fetch';
class FitButton extends Component {
    constructor(props) {
        super(props);
        this.onClickFitButton = (e) => {
            const { onControlClick } = this.props;
            e.preventDefault();
            e.stopPropagation();
            if (onControlClick) {
                onControlClick();
                return;
            }
            const { handleAddDemoFavorite, handleAddFavorite, handleDeleteDemoFavorite, handleDeleteFavorite, isDemo, isFavoriteSubmitting, } = this.props;
            const hasFavorite = this.getHasFavorite();
            let enableSubmit = true;
            let handleMain;
            if (isDemo) {
                handleMain = hasFavorite
                    ? handleDeleteDemoFavorite
                    : handleAddDemoFavorite;
            }
            else {
                enableSubmit = !isFavoriteSubmitting;
                handleMain = hasFavorite ? handleDeleteFavorite : handleAddFavorite;
            }
            if (enableSubmit) {
                this.setState({ isChanged: true });
                handleMain(e);
            }
        };
        this.onKeyDownFitButton = (e) => {
            e.preventDefault();
            e.stopPropagation();
        };
        this.getHasFavorite = () => {
            const { hasDemoFavorite, isDemo, item } = this.props;
            if (isDemo) {
                return hasDemoFavorite;
            }
            return item.hasFavorite;
        };
        this.getButtonClass = () => {
            const hasFavorite = this.getHasFavorite();
            const { isChanged } = this.state;
            if (hasFavorite) {
                return isChanged ? 'on' : 'checked';
            }
            return '';
        };
        this.state = {
            isChanged: false,
        };
    }
    render() {
        const { auth, isDemo, wrapClassName, wrapComponent } = this.props;
        const Wrap = wrapComponent;
        const isClient = isClientMember(auth);
        const isDisabled = !isDemo && !isClient;
        const btnClass = this.getButtonClass();
        return (_jsx(Wrap, Object.assign({ className: `${wrapClassName} solution-box-fit ${btnClass}` }, { children: _jsx("button", Object.assign({ className: `wcb-chan ${!isDisabled ? '' : 'is-disabled'}`, disabled: isDisabled, onClick: this.onClickFitButton, onKeyDown: this.onKeyDownFitButton, type: 'button' }, { children: _jsx("i", Object.assign({}, { 'fit-flag': btnClass ? 1 : 0 })) })) })));
    }
}
FitButton.propTypes = {
    auth: propShape().isRequired,
    handleAddDemoFavorite: propFunc().isRequired,
    handleAddFavorite: propFunc().isRequired,
    handleDeleteDemoFavorite: propFunc().isRequired,
    handleDeleteFavorite: propFunc().isRequired,
    hasDemoFavorite: propBool().isRequired,
    isDemo: propBool().isRequired,
    isFavoriteSubmitting: propBool().isRequired,
    item: propShape().isRequired,
    onControlClick: propFunc(),
    wrapClassName: propStr(),
    wrapComponent: propStr(),
};
FitButton.defaultProps = {
    onControlClick: undefined,
    wrapClassName: '',
    wrapComponent: 'div',
};
const mapStateToProps = ({ auth, demoSolution, fetch }, { item }) => ({
    auth,
    hasDemoFavorite: !!demoSolution.hasFavorite,
    isFavoriteSubmitting: isLoadingApis(fetch, {
        apiPath: `/client/solution/favorite/${item.id}`,
    }),
});
const mapDispatchToProps = (dispatch, { item }) => ({
    handleAddDemoFavorite: () => dispatch(createDemoFavorite()),
    handleAddFavorite: () => dispatch(apiCreateFavorite(item.id)),
    handleDeleteDemoFavorite: () => dispatch(deleteDemoFavorite()),
    handleDeleteFavorite: () => dispatch(apiDeleteFavorite(item.id)),
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(FitButton);
